import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { useTexts } from '@/feature/lang';
import { DocumentTitle } from '@/view/app/routing/DocumentTitle';
import { NotFound } from '../app/routing/NotFound';
import {
  cartPath,
  catalogsPath,
  ordersPath,
  recommendationsPath,
  searchPartsFullPath,
  searchPartsPath,
  shoppinglistsPath,
} from '../pathDefinitions';
import CartRoutes from './cart/routes';
import CatalogRoutes from './catalog/routes';
import OrderRoutes from './orders/routes';
import RecommendationRoutes from './recommendation/routes';
import SearchRoutes from './search/routes';
import ShoppingListRoutes from './shoppinglists/routes';

export default function EcomRoutes() {
  const { ecom, app } = useTexts();

  return (
    <Suspense fallback={<></>}>
      <Routes>
        <Route path="/" element={<Navigate to={searchPartsPath} replace />} />
        <Route
          path="parts/*" // Redirect legacy /ecom/parts/ to /ecom/search/
          element={<Navigate to={searchPartsFullPath} replace />}
        />
        <Route
          path={`${searchPartsPath}/*`}
          element={
            <>
              <DocumentTitle title={ecom.search.header} />
              <SearchRoutes />
            </>
          }
        />
        <Route
          path={`${catalogsPath}/*`}
          element={
            <>
              <DocumentTitle title={ecom.catalog.list.header} />
              <CatalogRoutes />
            </>
          }
        />
        <Route
          path={`${recommendationsPath}/*`}
          element={
            <>
              <DocumentTitle title={ecom.recommendation.list.header} />
              <RecommendationRoutes />
            </>
          }
        />
        <Route
          path={`${shoppinglistsPath}/*`}
          element={
            <>
              <DocumentTitle title={ecom.sidebar.shoppinglists} />
              <ShoppingListRoutes />
            </>
          }
        />
        <Route
          path={`${ordersPath}/*`}
          element={
            <>
              <DocumentTitle title={ecom.order.list.header} />
              <OrderRoutes />
            </>
          }
        />
        <Route
          path={`${cartPath}/*`}
          element={
            <>
              <DocumentTitle title={ecom.cart.content.title} />
              <CartRoutes />
            </>
          }
        />
        <Route
          path="*"
          element={
            <>
              <DocumentTitle title={app.routing.notFound.title} />
              <NotFound />
            </>
          }
        />
      </Routes>
    </Suspense>
  );
}
